// extracted by mini-css-extract-plugin
export default {"wrapper":"menulayout_wrapper__jbVXb","content":"menulayout_content__kOpXu","footer":"menulayout_footer__Mxtih"};